import typeCheck from 'common/util/typeCheck';

import {
  SR_API_ACTION_SUNLOCK_GET_BY_ID,
} from 'api/actionTypes';

export default async function getSunlockById({ state, apiClient }, { sunlockId }) {
  typeCheck('sunlockId::PositiveNumber', sunlockId);
  const statePath = ['sunlocks', 'byId', sunlockId];
  if (state.exists(statePath)) {
    return state.get(statePath);
  }

  await apiClient.postWithState({
    action: SR_API_ACTION_SUNLOCK_GET_BY_ID,
    state: state,
    queryId: `${sunlockId}`,
    payload: {
      sunlockId,
    },
    onSuccess(sunlock) {
      state.set(statePath, sunlock);
    },
  });
}
